import { View } from 'backbone';
import NProgress from 'nprogress';
import _ from 'underscore';
import Account from './account';
import Spinner from './spinner';

export default class NewsLetterFormView extends View {
    preinitialize() {
        this.spinner = new Spinner();

        this.events = {
            'focus .has-error': this.handleFocusError,
            submit: this.handleSubmit,
        };
    }

    initialize(options) {
        // Set list name from options
        this.list = options.list;
        this.google_site_key = options.google_site_key || null;

        // Define message box
        this.msgBox = this.el.querySelector('[data-part="msg"]');
        if (this.msgBox === null) {
            console.warn('Container for messages not found');
        }

        // Populate newsletter form with Account data
        this.populateForm(Account.get());
    }

    handleFocusError($e) {
        this.clearFieldError($e.currentTarget);
    }

    clearFieldError(field) {
        // Remove error class for this field
        field.classList.remove('has-error');
    }

    handleSubmit($e) {
        if ($e instanceof Object) {
            $e.preventDefault();
        }

        return this.subscribe();
    }

    subscribe() {
        const email = this.el.querySelector('[name="email"]').value;
        const nameField = this.el.querySelector('[name="name"]').value;

        let name;

        if (nameField) {
            name = nameField.value;
        }

        // Remove any error messages
        this.$el.find('[id^="msg-error-"]').remove();

        // Remove error class
        this.$el.find('.has-error').removeClass('has-error');

        const emailOnlyForm = {
            email,
        };

        const fullContactForm = {
            email,
            name,
        };

        let formData;

        if (name !== '') {
            formData = fullContactForm;
        } else {
            formData = emailOnlyForm;
        }

        // Add data initialized from view
        formData.list = this.list;
        formData.lang = HJ.Config.language;

        /**
         * Subscribe
         */

        const submitBtn = this.el.querySelector('.newsletter-btn');
        submitBtn.disabled = true;
        this.spinner.spin(submitBtn);

        NProgress.start();

        window.grecaptcha.ready(() => {
            window.grecaptcha
                .execute(this.google_site_key, {
                    action: 'newsletter_subscribe',
                })
                .then((token) => {
                    formData.recaptcha_token = token;
                    fetch(HJ.Config.api_url + '/newsletter', {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(formData),
                    })
                        .then((response) => {
                            if (response.ok) {
                                return response.json().then((data) => {
                                    NProgress.inc();

                                    // Remove form
                                    this.$el.find('form').empty();

                                    // Show success message
                                    this.showMessageSuccess();

                                    // Save form field data for future use
                                    Account.save(
                                        _.pick(formData, ['email', 'name'])
                                    );

                                    // Record signup
                                    window.dataLayer &&
                                        window.dataLayer.push({
                                            event: 'signup',
                                            event_category: 'Newsletter',
                                            event_label: this.list + ' signup',
                                            'edm.list': this.list,
                                        });

                                    NProgress.done();

                                    return data;
                                });
                            } else {
                                return response.json().then((data) => {
                                    // Create and throw error
                                    const e = new Error(
                                        data.exception[0].message
                                    );
                                    e.name = data.exception[0].type;
                                    throw e;
                                });
                            }
                        })
                        .catch((e) => {
                            console.error(e);

                            // Show error message
                            this.showMessageErrorSend();
                        })
                        .finally(() => {
                            NProgress.done();
                            submitBtn.disabled = false;
                            this.spinner.stop();
                        });
                });
        });
    }

    populateForm(data) {
        this.el.querySelector('[name="email"]').value = data.email || '';
    }

    showMessageErrorSend() {
        this.msgBox.innerHTML = this.el.querySelector(
            '#tmpl-msg-error-send'
        ).innerHTML;
    }

    showMessageSuccess() {
        this.msgBox.innerHTML = this.el.querySelector(
            '#tmpl-msg-success-send'
        ).innerHTML;
    }

    clearMessages() {
        this.msgBox.innerHTML = '';
    }
}
